import { PurposeEnum } from "../../models/Purpose";
import translate from "../../services/Translate";

export const generateRemoteUrl = (
  searchQuery?: string,
  showOnlyActive?: boolean,
  selectedLanguageFilters?: string[],
  selectedPurposeFilters?: PurposeEnum[]
) => {
  const params = new URLSearchParams();

  if (searchQuery) {
    params.append("search", searchQuery.toLowerCase());
  }

  if (selectedLanguageFilters && selectedLanguageFilters.length > 0) {
    params.append("language", selectedLanguageFilters.join(","));
  }

  if (selectedPurposeFilters && selectedPurposeFilters.length > 0) {
    params.append("purpose", selectedPurposeFilters.join(","));
  }

  if (showOnlyActive !== undefined) {
    params.append("get_deprecated", showOnlyActive ? "false" : "true");
  }

  return `modules${params.toString() ? `?${params.toString()}` : ""}`;
};

export const languageOptions = (language: string) => [
  { value: "fr-FR", display: translate(language, "PAGES.MODULES.LANGUAGES.FR") },
  { value: "en-US", display: translate(language, "PAGES.MODULES.LANGUAGES.US") },
];
